import {
  ChatSidebarTabs,
  completeSession,
  promptDiagnosis,
} from '../../../slices/chat/ChatSlice';
import VHTypeNavigation from './VHTypeNavigation';
import VHDefaultConfig from './VHDefaultConfig';
import VHVitals from '../medical/VHVitals/VHVitals';
import VHTypes from './VHTypes';

const VHMedicalConfig = {
  ...VHDefaultConfig,
  type: VHTypes.MEDICAL,
  navigationLocations: [
    VHTypeNavigation.DETAILS,
    VHTypeNavigation.OBJECTIVES,
    VHTypeNavigation.BUILDER,
    VHTypeNavigation.ACTIONS,
    VHTypeNavigation.VITALS,
    VHTypeNavigation.STATES,
    VHTypeNavigation.DIAGNOSIS,
    VHTypeNavigation.AI_FALLBACKS,
    VHTypeNavigation.AI_GENERATOR,
    VHTypeNavigation.TRAINING,
    VHTypeNavigation.PREVIEW,
    VHTypeNavigation.COMPLETIONS,
    VHTypeNavigation.ANALYTICS,
    VHTypeNavigation.OBJECTIVES_ANALYTICS,
    VHTypeNavigation.SESSIONS,
  ],
  finishButtonText: (vhDBVh) =>
    vhDBVh?.disableDiagnosis ? 'endConversation' : 'diagnose',
  finishPromptText: (vhDBVh) =>
    vhDBVh?.disableDiagnosis ? 'proceed' : 'proceedToDiagnosis',
  endsConversationPromptText: (_vhDBVh) => 'endMedicalConversationPromptText',
  postObjectivesCompletePromptText: (vhDBVh) =>
    !vhDBVh?.disableDiagnosis
      ? 'medicalCompleteWithDiagnosePrompt'
      : 'medicalCompleteWithoutDiagnosePrompt',
  finishWarningText: (vhDBVh) =>
    vhDBVh?.disableDiagnosis
      ? 'endConversationPrompt'
      : 'endMedicalConversationPrompt',
  onFinishSession: (dispatch, vhDBVh) => {
    if (vhDBVh?.disableDiagnosis) {
      dispatch(
        completeSession({
          patientId: vhDBVh.id,
        })
      );
    } else {
      dispatch(promptDiagnosis());
    }
  },
  overlayComponent: () => <VHVitals />,
  chatSidebarTabs: {
    VITALS: ChatSidebarTabs.VITALS,
    CHAT: ChatSidebarTabs.CHAT,
    ACTIONS: ChatSidebarTabs.ACTIONS,
    RESULTS: ChatSidebarTabs.RESULTS,
  },
  actionIcon: 'stethoscope',
  sidebarVisibleAtStart: true,
  usesCondition: true,
  usesDialogflow: true,
};
export default VHMedicalConfig;
